export function SettlementBadge({
  label = "Saldo rate Stripe",
}: {
  label?: string;
}) {
  return (
    <span className="px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap bg-teal-50 text-teal-800 border border-teal-300">
      {label}
    </span>
  );
}
